import { Box, Button, CircularProgress, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import React, { useContext, useState } from 'react'
import { useSelector } from 'react-redux';
import AppContext from '../../state/AppContext';
import DeleteIcon from '@mui/icons-material/Delete';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ConfirmDialog from '../../template/ConfirmDialog';
import APIInvoke from '../../utils/APIInvoke';
import toast from 'react-hot-toast';
import { deleteIndex, updateGeneralesEvent } from './edit-collections-actions';
import WarningIcon from '@mui/icons-material/Warning';

const EditCollectionIndexes = (props) => {

    const location = useLocation();
    const { appContext } = useContext(AppContext)
    const project = appContext.project
    let { collection } = useParams()
    const state = useSelector(state => state.pages.editCollection)
    const navigate = useNavigate()
    const [showDeleteDialog, setShowDeleteDialog] = useState({
        open: false,
        id: null
    })
    const [showReindexDialog, setShowReindexDialog] = useState(false)

    const onRowClick = (event, row) => {
        navigate(`/projects/${project}/collections/${collection}/indexes/${row.id}`, { state: { backLink: location.pathname } })
    }

    const onDeleteToken = async (project) => {
        const response = await (await APIInvoke.invokeDELETE(`/projects/${project}/collections/${collection}/indexes/${showDeleteDialog.id}`)).json()

        if (response.ok) {
            toast.success(response.message)
            deleteIndex(showDeleteDialog.id);

            setShowDeleteDialog({
                open: false,
                id: undefined
            })
        } else {
            toast.error(response.message)
        }
    }

    const toggleDeleteIndexDialog = (event, row) => {
        event.stopPropagation();
        setShowDeleteDialog({
            open: !showDeleteDialog.open,
            id: row?.id
        })
    }

    const startReindex = (e) => {
        e.preventDefault()
        setShowReindexDialog(false)
        APIInvoke.invokePOST(`/projects/${project}/collections/${collection}/reindex`)
        .then(response => response.json())
        .then(response => {
            if (response.ok) {
                updateGeneralesEvent({ reindexing: false })
                toast.success(response.message)
            } else {
                toast.error(response.message)
            } 
        })
        
        updateGeneralesEvent({ reindexing: true })
    }

    return (
        <>  
            <ConfirmDialog title="Reindex" message="Do you want to start a reindexing process? this process take several minutes." open={showReindexDialog} onClose={() => setShowReindexDialog(false)} onConfirm={startReindex} color="orange" />
            <ConfirmDialog title="Delete Index" message="This action is permanent and there will be no way to recover the index" open={showDeleteDialog.open} onClose={toggleDeleteIndexDialog} onConfirm={() => onDeleteToken(project)} />
            <form>
                <div className="grid gap-8 p-4 ">
                    <p className="text-md border-b pb-4 text-gray-800">Indexes are used to speed up the search process. You can create a new index by clicking on the button below.</p>
                    <div className="flex justify-between">
                        <div className="flex items-center gap-2">
                            <Button type="button"  onClick={() => setShowReindexDialog(true)}  color='warning' variant='contained' className="flex gap-1" disabled={state.reindexing} >{state.reindexing ? <CircularProgress color="success" size={16}/> : <WarningIcon fontSize="small" />} REINDEX</Button>
                            {state.reindexing && <span className="text-red-500 flex items-center gap-1">A reindexing process is currently running.</span>}
                        </div>
                        <Button variant="contained" color="primary" className="" onClick={() => navigate(`/projects/${project}/collections/${collection}/indexes/new`)} ><span className="ml-1 text-white flex items-center"><AddIcon /> NEW INDEX</span></Button>
                    </div>
                    <div className="grid grid-cols-1 gap-4">
                        <Box >
                            <Paper >
                                <TableContainer>
                                    <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={"small"}  >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align={'left'} padding={'normal'} >
                                                    <TableSortLabel >Name</TableSortLabel>
                                                </TableCell>
                                                <TableCell align={'left'} padding={'normal'} >
                                                    <TableSortLabel >Type</TableSortLabel>
                                                </TableCell>
                                                <TableCell align={'left'} padding={'normal'} >
                                                    <TableSortLabel >Expression</TableSortLabel>
                                                </TableCell>
                                                <TableCell align={'right'} padding={'normal'} >
                                                    <TableSortLabel >Actions</TableSortLabel>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {state.indexes.map((row, index) => {
                                                return (
                                                    <TableRow
                                                        hover
                                                        tabIndex={-1}
                                                        key={row.id}
                                                        onClick={(event) => onRowClick(event, row)}
                                                        sx={{ cursor: 'pointer' }}
                                                    >
                                                        <TableCell align="left">{row.name}</TableCell>
                                                        <TableCell align="left">{row.type}</TableCell>
                                                        <TableCell align="left">{row.expression}</TableCell>
                                                        <TableCell width={130} align="right">
                                                            <Tooltip title="Delete">
                                                                <IconButton  ><DeleteIcon className="hover:text-red" onClick={(event) => toggleDeleteIndexDialog(event, row)} /></IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Box>
                    </div>
                </div>
            </form>
        </>
    )
}

export default EditCollectionIndexes;